import { Col, Container, Modal, Row, Button } from "react-bootstrap";

export default function SmartModal ({ 
    
    // --- modal info
    showModal = false,
    modalMessage = null,
    
    // --- button callbacks
    onCancel = () => {},
    onConfirm = async () => {},

    // --- button styles
    cancelButtonLabel = 'Cancel',
    cancelButtonColor = 'secondary',

    confirmButtonLabel = 'Confirm',
    confirmButtonColor = 'primary',

    // --- http request
    isLoading = false,

    // --- styles
    size = 'sm',
    textCenter = false,

    // --- misc
    children,
    hideButtons = false,
    hideModal = false,
    modalStatus,
    modalHeaderText = '',
    staticDisplay = false,

    // --- auth
    disabled = false,
    disableConfirmButton = false,

    messageStyle,

    modalWidth,

    modalStyle,

    modalBodyStyle,
    modalBodyClassName = '',

    containerStyle,

    closeButton = false,

    additionalButtons,

}) {

    return (
        <Modal 
        centered 
        size={size} 
        onHide={onCancel} 
        show={showModal && hideModal === false} 
        style={{minWidth: modalWidth, maxWidth: modalWidth, ...modalStyle, backgroundColor: 'rgba(0,0,0,0.6)'}} 
        backdrop={staticDisplay}
        className="position-fixed top-50 start-50 translate-middle">

            {closeButton&&(
                <Modal.Header closeButton>
                    <span className="fw-bold fs-4">
                        {modalHeaderText}
                    </span>
                </Modal.Header>
            )}

            <Modal.Body style={modalBodyStyle} className={`${modalBodyClassName}`}>
                <Container 
                className="mt-1 d-flex flex-column" 
                style={{ 
                    maxWidth: 'unset',
                    pointerEvents: isLoading ? 'none': 'auto',
                    ...containerStyle,
                }}>
                    <Row className={`${textCenter ? 'text-center' : 'text-start'} fw-bold d-flex align-items-center justify-content-between`}>

                        {modalMessage && (
                            <span style={{width: 'fit-content', ...messageStyle}}>
                                {modalMessage}
                            </span>
                        )}

                    </Row>
                    {children}
                </Container>
            </Modal.Body>

            <Modal.Footer hidden={hideButtons}>
                {isLoading === false && (
                    <Row>
                        <Col style={{gap: '1rem'}} className="d-flex flex-wrap align-items-center justify-content-end p-0 mx-0 w-100">
                            <Button className={`btn-${cancelButtonColor}`} onClick={() => onCancel?.()}>
                                {cancelButtonLabel}
                            </Button>
                            <Button className={`btn-${confirmButtonColor}`} onClick={() => onConfirm?.()}>
                                {confirmButtonLabel}
                            </Button>
                        </Col>
                    </Row>
                )}
            </Modal.Footer>
        </Modal>
    );
};
